/**
 * Guest booking: a member (`bookedBy`) booked this seat for `user` from their
 * own pack. Returns the chip label for such a booking, or null for an ordinary
 * one. The admin list/detail endpoints return `bookedBy` as a bare id today, so
 * the booker's name shows only when the API populates it (`bookedByUser` or an
 * object `bookedBy`); otherwise the label is a plain "Guest booking".
 */
const idOf = (v: any): string => (v && typeof v === 'object' ? String(v._id ?? '') : v ? String(v) : '');

export function guestBookingLabel(booking: any): string | null {
  const bookedBy = idOf(booking?.bookedBy);
  if (!bookedBy || bookedBy === idOf(booking?.user)) return null;
  const name =
    booking?.bookedByUser?.name ||
    (typeof booking?.bookedBy === 'object' ? booking.bookedBy?.name : undefined);
  return name ? `Guest of ${name}` : 'Guest booking';
}
